import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import messages from './messages';
import EDeskLogo from './svgs/edesk-logo.svg';
import { linkIDs } from '../../../services/link-service/links';
import HelpArticleLink from '../../../components/help-article-link';

import style from './style.module.less';

export const Edesk = () => {
  const intl = useIntl();
  return (
    <div className={style['settings-section']}>
      <img alt={intl.formatMessage(messages.edeskLogo)} src={EDeskLogo} />
      <div className={style.subtext}>
        <FormattedMessage {...messages.eDesk} />
      </div>
      <ul className={style.list}>
        <li className={style['list-item']}>
          <FormattedMessage {...messages.loginEDesk} />
        </li>
        <li className={style['list-item']}>
          <FormattedMessage {...messages.path} />
        </li>
        <li className={style['list-item']}>
          <FormattedMessage {...messages.copyPaste} />
        </li>
        <li className={style['list-item']}>
          <FormattedMessage {...messages.saveChanges} />
        </li>
      </ul>
      <div className={style.bottomText}>
        <FormattedMessage
          {...messages.clickHere}
          values={{
            a: (chunks) => <HelpArticleLink articleId={linkIDs.EDesk}>{chunks}</HelpArticleLink>,
          }}
        />
      </div>
    </div>
  );
};
